import React from 'react';
import { Container, Box, Typography, Paper } from '@mui/material';
import ReactPlayer from 'react-player';
import { useParams } from 'react-router-dom';

const VideoPlayer = () => {
  const { videoId } = useParams();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Your Extended Forecast
      </Typography>

      <Paper sx={{ p: 2, bgcolor: 'black' }}>
        <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
          <ReactPlayer
            url={`https://vimeo.com/${videoId}`}
            width="100%"
            height="100%"
            style={{ position: 'absolute', top: 0, left: 0 }}
            controls={true}
          />
        </Box>
      </Paper>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          Video Chapters
        </Typography>
        <Typography paragraph>
          0:00 - Introduction<br />
          5:00 - Major Transits Overview<br />
          15:00 - January-March Forecast<br />
          25:00 - April-June Forecast<br />
          35:00 - July-September Forecast<br />
          45:00 - October-December Forecast<br />
          55:00 - Key Takeaways
        </Typography>
      </Box>
    </Container>
  );
};

export default VideoPlayer;